import { useIframeFlow } from '@/src/hooks/useIframeFlow'
import { isIframeRequest } from '@/src/utils/iframeUtils'
import { useRouter } from 'next/router'

const IframeFlowHandler = () => {
  const { isProcessingIframe } = useIframeFlow()
  const router = useRouter()

  // Don't render on login page or if not an iframe request
  if (!isIframeRequest() || router.pathname === '/login') {
    return null
  }

  return (
    <>
      {isProcessingIframe && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center'
            }}
          >
            <p>Processing request...</p>
          </div>
        </div>
      )}
    </>
  )
}

export default IframeFlowHandler
